import { useEffect } from 'react';
type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: FbqFunction;
  loaded: boolean;
  version: string;
};
type MetaPixelWindow = Window & {
  fbq?: FbqFunction;
  _fbq?: FbqFunction;
  __metaPixelInitialized?: boolean;
  __metaPixelPageViewTracked?: boolean;
};
const META_PIXEL_ID = '1759615398541763';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    const metaWindow = window as MetaPixelWindow;
    if (!metaWindow.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
          return;
        }
        fbq.queue.push(args);
      } as FbqFunction;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      metaWindow.fbq = fbq;
      metaWindow._fbq = fbq;
    }
    if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = META_PIXEL_SCRIPT_ID;
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (!metaWindow.__metaPixelInitialized) {
      metaWindow.fbq('init', META_PIXEL_ID);
      metaWindow.__metaPixelInitialized = true;
    }
    if (!metaWindow.__metaPixelPageViewTracked) {
      metaWindow.fbq('track', 'PageView');
      metaWindow.__metaPixelPageViewTracked = true;
    }
  }, []);
  return <noscript data-id="element-111" data-mp="1mgayprhfvqyn">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-112" data-mp="1merlyauzry1m" />
    </noscript>;
}